import {stringHash} from "./stringHash";

export function harvestUploadObjId(src) {
  return src.start + src.end + stringHash(src.recipientName) + stringHash(src.place);
}
